import React from 'react';
import { ReactComponent } from 'Common/components/Icons/safety-vest.svg';

const SafetyVest = () => <ReactComponent className="MuiSvgIcon-root" />;

export default SafetyVest;
